import { Day, DayProps } from '@daypicker/react'
import { astraTwMerge, day, isSame, isWeekend } from 'astra'

import { AstraTooltip } from '../../../../AstraTooltip/AstraTooltip'
import { getDayCellStyles } from './AstraDayPickerDayStyles'

type ExpandedDayPickerProps = DayProps & {
    weekdaysOnly?: boolean
    showOutsideDays?: boolean
    fixedWeeks?: boolean
    tooltips?: { date: Date; text: string }[]
}

export const AstraDayPickerDay = ({ className, showOutsideDays, fixedWeeks, weekdaysOnly, tooltips, ...rest }: ExpandedDayPickerProps) => {
    const { day: renderDay, children } = rest

    const weekend = isWeekend(day(renderDay.date))

    if (renderDay.outside && !showOutsideDays && !fixedWeeks) {
        return weekdaysOnly && weekend ? <></> : <td />
    }

    if (weekdaysOnly && weekend) {
        return <></>
    }

    const tooltipText = tooltips?.find(t => isSame(t.date, renderDay.date, 'day'))?.text

    return (
        <Day
            {...rest}
            className={astraTwMerge('p-0 text-center', className, getDayCellStyles(rest.modifiers))}
            data-test={rest.modifiers.disabled ? 'booking-day-disabled' : 'booking-day-available'}
        >
            {tooltipText ? (
                <AstraTooltip tooltipContent={tooltipText}>
                    <div>{children}</div>
                </AstraTooltip>
            ) : (
                children
            )}
        </Day>
    )
}
